export const loadingManager = function () {
	var loading = '';

   	return { 
		loading: () => {
			return loading;
		},
		toggle: () => {
			loading != loading;
		},
		show: (message) => {
			document.getElementById('sdLoaderMessage').innerHTML = message;
			document.getElementById('sdLoader').style.display = 'flex';
			setTimeout(function() {
				document.getElementById('sdLoader').classList.remove('sdHideLoader');
			}, 100);
		},
		hide: () => {
			setTimeout(() => {
				document.getElementById('sdLoader').classList.add('sdHideLoader');
				setTimeout(function() {
				document.getElementById('sdLoader').style.display = 'none';
				}, 1100);
			}, 1200);
		}
   };
};